export default __webpack_public_path__ + "static/media/radio-unselected-tick.d4876db3.svg";